<template>
  <transition name="fade">
    <v-alert
      v-if="visible"
      :type="notification.style"
      :elevation="4"
      border="left"
      colored-border
      class="maintenance-alert"
      dismissible
      close-icon="mdi-close"
      @click="handleClick"
      @input="handleClose"
    >
      <div class="maintenance-content">
        <div class="maintenance-title">{{ notification.data.maintenance.title }}</div>
        <div class="maintenance-body">{{ notification.data.maintenance.text }}</div>
      </div>
    </v-alert>
  </transition>
</template>

<script>
export default {
  name: 'NotificationMaintenance',
  props: {
    notification: { type: Object, required: true },
    border: { type: String, default: 'left' },
  },
  data() {
    return {
      visible: true,
      clickedManually: false,
    };
  },
  methods: {
    handleClick() {
      this.$store.commit('notifications/clearMaintenanceOverlay');
      this.clickedManually = true;
      this.visible = false;

      if (this.notification?.data?.maintenance?.is_maintenance_force) {
        this.redirectToLogout();
      }
    },
    handleClose(val) {
      this.$store.commit('notifications/clearMaintenanceOverlay');
      if (!val && this.clickedManually) {
        this.$emit('clicked', this.notification);
      }
      if (!val) {
        this.$emit('closed', this.notification);
      }
    },
    redirectToLogout() {
      axios.get('/logout').then(() => this.$router.push('/login'))
    }
  },
};
</script>

<style scoped>
.maintenance-alert {
  position: fixed;
  bottom: 20px;
  left: 20px;
  max-width: 600px;
  min-width: 480px;
  padding: 24px;
  font-size: 16px;
  z-index: 9999;
}

.maintenance-title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 8px;
}

.maintenance-body {
  font-size: 15px;
  line-height: 1.5;
}
</style>
